import { Star } from "lucide-react";

export const StarRating = ({ value = 0, onChange, size = 18, testid = "star-rating" }) => {
  const interactive = typeof onChange === "function";
  const Tag = interactive ? "button" : "span";
  return (
    <span className="inline-flex items-center gap-0.5" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((s) => (
        <Tag
          key={s}
          {...(interactive ? { type: "button", onClick: () => onChange(s) } : {})}
          data-testid={`${testid}-star-${s}`}
          className={interactive ? "cursor-pointer transition-transform duration-150 hover:scale-110 inline-flex" : "inline-flex"}
        >
          <Star size={size} className={s <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"} />
        </Tag>
      ))}
    </span>
  );
};
